import React from 'react';
import styled, { css } from '../../styled';
import { Chevron } from '../icons/outline/Chevron';
import { Tick } from '../icons/solid/Tick';
import DropdownOptionWrapper from './DropdownOptionWrapper';
import DropdownOption from './DropdownOption';
const Selector = styled.div `
  color: ${({ theme }) => theme.colors.INK_800};
  ${({ disabledShadow, theme }) => !disabledShadow &&
    `box-shadow: 0 0.0625rem 0.125rem 0.0625rem ${theme.colors.SHADOW_DEFAULT};`}
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  ${({ contentPadding }) => `padding: ${contentPadding || '0.4375rem 0.25rem'};`}
  border-radius: 6px;
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  width: ${({ width }) => width};
  ${({ minHeight }) => minHeight ? `min-height:${minHeight}` : 'height: 2.125rem'};
  ${({ minHeight }) => minHeight && 'align-items: center;'};
  ${({ border }) => (border ? `border: ${border}` : '')};
  height: 2.125rem;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.PRIMARY_600};
    ${({ disabledShadow, theme }) => !disabledShadow &&
    `box-shadow: 0 0.0625rem 0.125rem 0.0625rem
      ${theme.colors.SHADOW_DEFAULT}, 0 0 1.5rem 0 ${theme.colors.SHADOW_LIGHT};`}
    > svg {
      fill: ${({ theme }) => theme.colors.PRIMARY_600};
    }
  }

  &:active {
    color: ${({ theme }) => theme.colors.PRIMARY_700};
    > svg {
      fill: ${({ theme }) => theme.colors.PRIMARY_700};
    }
  }

  > span {
    padding-left: 0.75rem;
    text-overflow: ellipsis;
    overflow: hidden;
    width: calc(100% - 1.25rem);
  }
  > svg {
    transition: transform 0.3s ease-in-out;
  }
`;
const Container = styled.span `
  display: inline-block;
  position: relative;
`;
const Checkbox = styled.div `
  width: 1rem;
  height: 1rem;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.INK_300};
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  display: inline-flex;
  position: relative;
  cursor: pointer;

  > svg {
    visibility: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
const CheckboxWrapper = styled.div `
  display: flex;
  color: ${({ theme }) => theme.colors.INK_800};
  padding: 0.75rem;
  > span {
    display: inline-flex;
    padding-left: 0.5rem;
  }

  ${props => props.selected === true &&
    css `
      ${Checkbox} {
        border: 1px solid ${({ theme }) => theme.colors.PRIMARY_600};
        > svg {
          visibility: inherit;
        }
      }
    `};

  ${props => props.disabled === true &&
    css `
      cursor: not-allowed;
      color: ${({ theme }) => theme.colors.INK_400};
      ${Checkbox} {
        border: 1px solid ${({ theme }) => theme.colors.INK_200};
      }
    `};

  ${props => props.disabled === false &&
    css `
      &:hover {
        color: ${({ theme }) => theme.colors.INK_700};
        ${Checkbox} {
          border: 1px solid ${({ theme }) => theme.colors.PRIMARY_600};
        }
      }
    `};
`;
const PlaceHolderWrapper = styled.span `
  ${props => props.themeColor &&
    css `
      color: ${({ theme }) => theme.colors[props.themeColor]};
    `};
`;
class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.isOptionSelected = (option) => {
            const { value } = this.props;
            return value.filter(v => v === option.value).length > 0;
        };
        this.closeWrapper = () => {
            const { onClose } = this.props;
            onClose();
        };
        this.handleOptionChange = (option) => () => {
            const { onChange, type, value } = this.props;
            let currentValue = [];
            if (type === 'multipleOption') {
                if (this.isOptionSelected(option)) {
                    currentValue = value.filter(element => element !== option.value);
                }
                else {
                    currentValue = value.concat(option.value);
                }
            }
            else if (type === 'singleOption') {
                currentValue = currentValue.concat(option.value);
                this.closeWrapper();
            }
            if (onChange) {
                onChange(currentValue);
            }
        };
        this.handleClickOutside = (event) => {
            const { isOpen } = this.props;
            if (this.dropdownContainerRef &&
                this.dropdownContainerRef.current &&
                !this.dropdownContainerRef.current.contains(event.target) &&
                isOpen) {
                this.closeWrapper();
            }
        };
        this.handleValueToLabel = (value) => {
            const { options } = this.props;
            const currentOption = options.find(option => option.value === value);
            if (currentOption) {
                return currentOption.label;
            }
            return '';
        };
        this.dropdownContainerRef = React.createRef();
    }
    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('mousedown', this.handleClickOutside);
        }
    }
    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mousedown', this.handleClickOutside);
        }
    }
    render() {
        const { isOpen, placeHolder, placeHolderColor, value, width, options, type, menuAlign, minHeight, optionMaxHight, optionMarginTop, disabledShadow, contentPadding, border, onClick, renderSelector, className, e2eId, } = this.props;
        return (React.createElement(Container, { "data-e2e-id": e2eId, className: className, ref: this.dropdownContainerRef },
            renderSelector ? (renderSelector({ onSelectorClick: onClick, isOpen })) : (React.createElement(Selector, { onClick: onClick, width: width, border: border, minHeight: minHeight, disabledShadow: disabledShadow, contentPadding: contentPadding },
                value.length === 0 && (React.createElement(PlaceHolderWrapper, { themeColor: placeHolderColor || 'INK_800' }, placeHolder)),
                value.length > 0 && (React.createElement("span", null, value.map((v, index) => (React.createElement("span", { key: v },
                    index > 0 && `,${this.handleValueToLabel(v)}`,
                    index === 0 && `${this.handleValueToLabel(v)}`))))),
                React.createElement(Chevron, { position: isOpen ? 'TOP' : 'BOTTOM', size: "MEDIUM" }))),
            React.createElement(DropdownOptionWrapper, { isOpen: isOpen, menuAlign: menuAlign, width: width, optionMaxHight: optionMaxHight, optionMarginTop: optionMarginTop }, options.map(option => {
                const optionDisabled = option.disabled || false;
                if (type === 'multipleOption') {
                    return (React.createElement(CheckboxWrapper, { selected: this.isOptionSelected(option), disabled: optionDisabled, onClick: optionDisabled ? undefined : this.handleOptionChange(option), key: option.value },
                        React.createElement(Checkbox, null,
                            React.createElement(Tick, { size: "SMALL", color: "PRIMARY_600" })),
                        React.createElement("span", null, option.label)));
                }
                return (React.createElement(DropdownOption, { e2eId: option.e2eId, key: option.key, selected: this.isOptionSelected(option), disabled: optionDisabled, onClick: this.handleOptionChange(option), color: option.color || 'INK_800', iconColor: option.iconColor || option.color || 'INK_800', Icon: option.Icon, label: option.label }));
            }))));
    }
}
Dropdown.defaultProps = {
    type: 'singleOption',
    menuAlign: 'left',
    width: '160px',
};
export default Dropdown;
//# sourceMappingURL=Dropdown.js.map